import React from 'react'
import ActionPanelProvider from '../../../components/layout/contextProvider/ActionPanelProvider'
import DetailPanelProvider from '../../../components/layout/contextProvider/DetailPanelProvider'
import DialogProvider from '../../../components/layout/contextProvider/DialogProvider'
import { FilterPanelContext } from '../../../components/layout/rightPanels'
import PlanningComponents from './PlanningComponents'
import { PAGE, usePageContext } from '../../../components/layout/PageContext'

const Planning = () => {
	const { setPage } = usePageContext()

	React.useEffect(() => {
		setPage(PAGE.PLANNING)
	}, [])

	return <DialogProvider>
		<DetailPanelProvider>
			<ActionPanelProvider Context={FilterPanelContext} level={1}>
				<ActionPanelProvider>
					<PlanningComponents />
				</ActionPanelProvider>
			</ActionPanelProvider>
		</DetailPanelProvider>
	</DialogProvider>
}

export default Planning
